import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output, QueryList,
  Renderer2,
  ViewChild, ViewChildren
} from '@angular/core';
import { kanbanData } from '../data';
import {
  CardSettingsModel,
  DialogEventArgs,
  KanbanComponent, SortSettingsModel
} from '@syncfusion/ej2-angular-kanban';
import { BehaviorSubject, finalize, ReplaySubject, Subject, takeUntil, throttleTime, timeout } from 'rxjs';
import { Lead, LeadTask } from '../../../types/lead.type';
import { ContextMenuComponent, ContextMenuService } from 'ngx-contextmenu';
import { SnotifyPosition, SnotifyService } from 'ng-snotify';
import { AppService } from '../../../services/app.service';
import { InterfaceService } from '../../../services/interface.service';
import { SenderService } from '../../../services/sender.service';
import { LeadsService } from '../../../modules/leads/services/leads.service';
import { ModalService } from '../../../services/modal.service';
import { IMessageLead, WebsocketService } from '../../../services/websocket';
import { AllService } from '../../../services/all.service';
import { AllMessengersService } from '../../page-start/all-messengers.service';
import { NzTooltipBaseComponent, NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { TelegramService } from '../../page-telegram/telegram.service';
import { debounceTime, filter } from 'rxjs/operators';
import { Message } from '../../../types/all.type';
import { NotifierWrapService } from '../../../services/notifier-wrap.service';

@Component({
  selector: 'app-leads-scan-tasks-kanban',
  templateUrl: './leads-scan-tasks-kanban.component.html',
  styleUrls: ['./leads-scan-tasks-kanban.component.scss']
})
export class LeadsScanTasksKanbanComponent implements OnInit, AfterViewInit {
  private destroy$: Subject<void> = new Subject();
  public isLoadError$: BehaviorSubject<false | Error> = new BehaviorSubject(false);
  public toolTopLead$: BehaviorSubject<Lead | false> = new BehaviorSubject(false);
  @ViewChildren(NzTooltipDirective) tooltips: QueryList<NzTooltipDirective>;
  @ViewChild('kanbanObj') kanbanObj: KanbanComponent;
  public kanbanData$: BehaviorSubject<Lead[]> = new BehaviorSubject([]);
  public isLoading$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  public data: any[] = kanbanData;
  @ViewChild(ContextMenuComponent) public contextMenuLead: ContextMenuComponent;
  @Output() onTaskAdd = new EventEmitter<void>();
  tooltipVisibleChange$ = new EventEmitter<boolean>(false);
  Service: TelegramService;
  public columns = [
    {headerText: 'Новые', keyField: 'New', isExpanded: true, icon: 'message-square'},
    {headerText: 'В обработке', keyField: 'Process', isExpanded: true, icon: 'loader'},
    {headerText: 'Завершенные', keyField: 'Completed', isExpanded: true, icon: 'check-circle'},
    {headerText: 'Отказ', keyField: 'Cancel', isExpanded: true, icon: 'minus-circle'},
  ];

  @ViewChild('leadTooltip') public leadTooltip: NzTooltipBaseComponent;
  // public kanbanData: any[] = extend([], [], null, true) as any[];
  public cardSettings: CardSettingsModel = {
    headerField: 'Id',
    contentField: 'Description',
  };
  public sortSettings: SortSettingsModel = {
    sortBy: 'Custom',
    field: 'message_time',
    direction: 'Descending',
  };
  public categoryData: string[] = [
    'Menu',
    'Order',
    'Ready to Serve',
    'Delivered',
    'Served',
  ];

  onDialogClose(args: DialogEventArgs) {
    if (args.element.querySelector('Date') as any) {
      args.data.Date = (args.element.querySelector('#Date') as any).ej2_instances[0].value.toLocaleString('es-PR').split(',')[0];
    }
  }

  constructor(
    public notifierWrapService: NotifierWrapService,
    public cd: ChangeDetectorRef,
    private allMessengersService: AllMessengersService,
    public allService: AllService,
    public wsService: WebsocketService,
    private modalService: ModalService,
    private snotifyService: SnotifyService,
    @Inject('ContextMenuServiceLead') public contextMenuService: ContextMenuService,
    // public contextMenuService: ContextMenuService,
    private appService: AppService,
    public interfaceService: InterfaceService,
    public renderer: Renderer2,
    public senderService: SenderService,
    public leadsService: LeadsService
  ) {
  }

  ngOnInit(): void {
    this.setService();
    if (this.interfaceService.isLeadsDomain && !this.senderService.getVarLocal('show_faq_video', false)) {
      this.modalService.openModal('ModalFirstFaqVideoComponent');
      this.senderService.setVarLocal('show_faq_video', true);
    }
    this.isLoading$.next(true);
    if (this.allMessengersService.isAuth) {
      this.leadsService.loadLeads$.next();
    }
    this.allService.wsService.on<IMessageLead>('lead')
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.setColor(data.lead);
        const kanbanDatas = [data.lead, ...this.kanbanData$.getValue()];
        this.kanbanData$.next(kanbanDatas);
      });

    if (!this.allService.wsService.isConnected) {
      this.allService.wsService.status
        .pipe(filter((v) => v), timeout(10000))
        .subscribe((v) => {
          this.leadsService.loadLeads$.next();
        }, e => {
          if (this.kanbanData$.getValue().length === 0) {
            this.leadsService.loadLeads$.next();
          }
        });
    }
    this.leadsService.loadLeads$.pipe(takeUntil(this.destroy$), debounceTime(1000))
      .subscribe((initiator) => {
        this.loadLeads();
      });
  }
  ngAfterViewInit() {
    if (this.allMessengersService.isAuth) {
      this.interfaceService.setFullSize(this.renderer);
    }else{
      this.interfaceService.setFullSize(this.renderer, false);
    }
  }
  loadLeads(): void {
    // this.isLoading$.next(true);
    this.isLoadError$.next(false);
    const accountId = this.senderService.account$.value.id;
    this.leadsService.getLeads(accountId, this.leadsService.filterWork).pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loadTasks(accountId);
      })
    )
      .subscribe((res) => {
        res.map((v) => {
          this.setColor(v);
        });
        if (res.length === 0) {

        } else {
          this.kanbanData$.next(res);
          this.isLoading$.next(false);
        }
      }, e => {
        this.isLoadError$.next(e);
        this.isLoading$.next(false);
      });
  }
  setColor(v: Lead) {
    v.color = this.appService.stringToHslColor(v.Ad);
    v.scope_class = 'danger';
    if (v.Scope > 0.6) {
      v.scope_class = 'success';
    } else if (v.Scope > 0.5) {
      v.scope_class = 'warning';
    }
  }

  closeTooltips(): void {
    this.tooltips.forEach(tooltip => tooltip.hide());
  }

  onDragLead($event: any) {
    this.closeTooltips();
    const data: Lead = $event.data[0];
    console.log($event, '$event');
    this.leadsService.updateLead(data).pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        console.log('', res);
      }, error => {
        this.interfaceService.errorHandling(error, true);
      });
  }

  openUserChat(data: Lead) {
    this.closeTooltips();
    this.leadsService.openUserChat(data, this.Service);
  }

  openMessage(data: Lead) {
    this.leadsService.openMessage(data, this.Service);
    this.closeTooltips();
  }

  /*replyMessage(data: Lead) {
    if (this.hasChat(data)) {
      this.openUserChat(data);
    } else {
      this.openMessage(data);
    }
  }*/

  public contextMenuOpen($event, item: Lead): void {
    this.closeTooltips();
    this.tooltipVisibleChange$.next(false);
    this.contextMenuService.show.next({
      anchorElement: $event.target,
      // Optional - if unspecified, all context menu components will open
      contextMenu: this.contextMenuLead,
      event: $event as any,
      item
    });
    $event.preventDefault();
    $event.stopPropagation();
  }

  deleteLeadFromKanban(id: number): void {
    const kanbanDatas = this.kanbanData$.getValue().filter((v) => v.id !== id);
    this.kanbanData$.next(kanbanDatas);
    this.cd.detectChanges();
  }

  deleteLead(item: Lead) {
    this.closeTooltips();
    this.snotifyService.clear();
    this.snotifyService.confirm(
      (item?.message.message?.text || item.Ad),
      `Удалить лид #${item.id}?`,
      {
        timeout: 30000,
        titleMaxLength: 100,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        position: SnotifyPosition.centerTop,
        buttons: [
          {
            text: 'Удалить',
            action: () => {
              this.leadsService.deleteLead(item.id).pipe()
                .subscribe((res) => {
                  this.deleteLeadFromKanban(item.id);
                }, error => {
                  this.interfaceService.errorHandling(error, true);
                });
            },
            bold: false
          },
          /*{
            text: 'Не спрашивать',
            action: () => {
              alert('TODO');
            },
            bold: false
          },*/
          {
            text: 'Нет',
          }
        ]
      }
    );
  }

  ignoreLead(item: Lead): void {
    this.closeTooltips();
    this.leadsService.deleteLead(item.id, true).pipe()
      .subscribe((res) => {
        this.deleteLeadFromKanban(item.id);
      }, error => {
        this.interfaceService.errorHandling(error, true);
      });
    /*this.snotifyService.clear();
    this.snotifyService.confirm(
      'Нажмите да, если лид не подходит',
      'Игнорировать лид?',
      {
        timeout: 30000,
        titleMaxLength: 100,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        position: SnotifyPosition.centerTop,
        buttons: [
          {
            text: 'Да',
            action: () => {
              this.leadsService.deleteLead(item.id, true).pipe()
                .subscribe((res) => {
                  this.deleteLeadFromKanban(item.id);
                }, error => {
                  this.interfaceService.errorHandling(error, true);
                });
            },
            bold: false
          },
          {
            text: 'Нет',
          }
        ]
      }
    );*/
  }

  clearColumn(column: string) {
    this.snotifyService.clear();
    this.snotifyService.confirm(
      (column),
      'Удалить все лиды из колонки?',
      {
        timeout: 30000,
        titleMaxLength: 100,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        position: SnotifyPosition.centerTop,
        buttons: [
          {
            text: 'Нет'
          },
          {
            text: 'Удалить',
            action: () => {
              const accountId = this.senderService.account$.value.id;
              this.leadsService.clearColumn(accountId, column).pipe()
                .subscribe((res) => {
                  this.loadLeads();
                  this.notifierWrapService.notify('success', 'Очистка лидов завершена, синхронизация...');                }, error => {
                  this.interfaceService.errorHandling(error, true);
                });
            },
            bold: false
          }
        ]
      }
    );
  }

  renderCount() {
    console.log('renderCount');
  }

  getColor(scope: number) {
    if (scope > 0.6) {
      return 'info';
    }
    if (scope > 0.5) {
      return 'success';
    }
    if (scope > 0.4) {
      return 'warning';
    }
    return 'danger';
  }

  reload(initiator = 'none') {
    this.isLoading$.next(true);
    this.leadsService.loadLeads$.next();
  }

  addScanTask() {
    this.closeTooltips();
    this.onTaskAdd.next();
    this.leadsService.editLeadTask$.next();
    setTimeout(() => {
      this.modalService.openModal('LeadsScanTasksEditModalComponent', {leadTask: false});
    }, 1000);
  }

  gerLeadUserId(data: Lead) {
    const fromUser = data.message.message.from_user;
    return fromUser?.username || fromUser?.id;
  }

  getLeadMessage(data: Lead) {
    const message: Message = {...data.message.message};
    message.out = false;
    message.online = false;
    return message;
  }

  openTooltip(data: Lead) {
    this.setService();
    this.interfaceService.isShowTextarea$.next(false);
    this.Service._openChatId = this.gerLeadUserId(data);
    delete this.Service._openChat;
    this.Service.editMessage = false;
    this.Service.replyMessage = false;
    this.interfaceService.focusTextArea$.next(true);
    this.toolTopLead$.next(data);
    setTimeout(() => {
      this.Service.forwardMessage = this.getLeadMessage(data);
    }, 500);
    if (!data.viewed) {
      data.viewed = true;
      this.leadsService.updateLead(data).pipe(takeUntil(this.destroy$))
        .subscribe((res) => {});
    }
  }

  closeLead() {
    /*if (this.interfaceService.isShowTextarea$.value) {
      this.interfaceService.isShowTextarea$.next(false);
      return true;
    }*/
    this.closeTooltips();
  }

  private loadTasks(accountId: number) {
    this.leadsService.getLeadsTasks(accountId).pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.isLoading$.next(false);
      })
    )
      .subscribe((res) => {
        this.leadsService.leadTasks$.next(res);
      }, e => {
        this.isLoadError$.next(e);
        this.isLoading$.next(false);
      });
  }
  setService(): void {
    this.Service = this.allMessengersService.arServicesAuthorized[0] as TelegramService;
    this.allMessengersService.Service = this.Service;
  }

}
